
import { jwtDecode } from "jwt-decode";

// utils/timeUtils.js
export const getTokenExpiry = (token) => {
    try {
        const decoded = jwtDecode(token);
        if (!decoded?.exp) return null;
        return decoded.exp * 1000; // Convert to milliseconds
    } catch {
        return null;
    }
};

export const calculateTimeLeft = (expiryTime) => {
    if (!expiryTime) return 0;
    return Math.max(0, expiryTime - Date.now());
};

export const formatTime = (ms) => {
    if (ms <= 0) return '00:00';
    const seconds = Math.floor(ms / 1000) % 60;
    const minutes = Math.floor(ms / (1000 * 60)) % 60;
    const hours = Math.floor(ms / (1000 * 60 * 60));

    if (hours > 0) {
        return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

export const isTokenValid = (token) => {
    const expiry = getTokenExpiry(token);
    return expiry && expiry > Date.now();
};